// extracted by mini-css-extract-plugin
export var quantityInput = "_eq-0";